import React from 'react';
import PropTypes from 'prop-types';
import HumLayout from '@narvar/hum-layout';
import { Route } from 'react-router';
import PageViewEmitter from '../../hooks/userEvents/PageViewEmitter';

const Layout = ({ component, path, exact, beacon }) => {
  return (
    <>
      <HumLayout
        component={component}
        exact={exact}
        path={path}
        route={Route}
      />
      <PageViewEmitter beacon={beacon} />
    </>
  );
};

Layout.defaultProps = {
  path: undefined,
  exact: false,
  beacon: undefined,
};

Layout.propTypes = {
  component: PropTypes.element.isRequired,
  path: PropTypes.string,
  exact: PropTypes.bool,
  beacon: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
};

export default Layout;
